import { Dimensions, Quantity, Unit } from '@elderbyte/ngx-starter'

export class StorageNodeDetails {
  public id: string

  public number: string

  public facility: string

  public type: StorageNodeType

  public path: string

  public description: string

  public packageCheckinMode: PackageCheckinMode
}

export class StorageNode {
  public id: string

  public number: string

  public facility: string

  public type: StorageNodeType

  public ancestors: string[]

  public parent: string

  public priority: number

  public path: string

  public description: string

  public capacity: StorageNodeCapacity = new StorageNodeCapacity()

  public packageCheckinMode: PackageCheckinMode
}

export enum StorageNodeType {
  Logical = 'LOGICAL',

  Physical = 'PHYSICAL',
}

export enum PackageCheckinMode {
  AUTO = 'AUTO',

  MANUAL_FIRST_ORDER_PACKAGE = 'MANUAL_FIRST_ORDER_PACKAGE',

  MANUAL = 'MANUAL',
}

export class StorageNodeCapacity {
  public minWeight: Quantity = Quantity.zero(Unit.kg)

  public maxWeight: Quantity = Quantity.zero(Unit.kg)

  public dimensions: Dimensions

  public multiOrderModeEnabled: boolean
}
